export const SET_CONNECTED = 'SET_CONNECTED';
export const SET_TEST_MESSAGE = 'SET_TEST_MESSAGE';
export const SET_SOCKET_AUTHENTICATED = 'SET_SOCKET_AUTHENTICATED';
export const SET_RECONNECT_ATTEMPTS = 'SET_RECONNECT_ATTEMPTS';
